import React from 'react';
import '../assets/styles/BenefitsSection.css';
import '../assets/styles/EnhancedBenefits.css';

const BenefitsSection: React.FC = () => {
  const benefits = [
      {
        id: 1,
        title: "Crafted for Peak Performance",
        description:
          "Every feature is designed with precision to deliver real value to traders. We don't just add tools—we refine, test, and perfect every element to maximize efficiency and impact.",
        icon: (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M40 16H36V12C36 10.9 35.1 10 34 10H30V6C30 4.9 29.1 4 28 4H8C6.9 4 6 4.9 6 6V18C6 19.1 6.9 20 8 20H12V24C12 25.1 12.9 26 14 26H18V30C18 31.1 18.9 32 20 32H28V36C28 37.1 28.9 38 30 38H40C41.1 38 42 37.1 42 36V18C42 16.9 41.1 16 40 16ZM40 36H30V32H34C35.1 32 36 31.1 36 30V24H40V36Z" fill="#2196F3"/>
          </svg>
        ),
      },
      {
        id: 2,
        title: "Unmatched & Innovative",
        description:
          "A unique approach that sets us apart from the rest. Our cutting-edge design and functionality aren't just different—they're a step ahead, redefining the trading experience.",
        icon: (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 4C12.95 4 4 12.95 4 24C4 35.05 12.95 44 24 44C35.05 44 44 35.05 44 24C44 12.95 35.05 4 24 4ZM24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40Z" fill="#4CAF50"/>
            <path d="M24 12C17.37 12 12 17.37 12 24C12 30.63 17.37 36 24 36C30.63 36 36 30.63 36 24C36 17.37 30.63 12 24 12ZM24 32C19.59 32 16 28.41 16 24C16 19.59 19.59 16 24 16C28.41 16 32 19.59 32 24C32 28.41 28.41 32 24 32Z" fill="#4CAF50"/>
            <circle cx="24" cy="24" r="4" fill="#4CAF50"/>
          </svg>
        ),
      },
      {
        id: 3,
        title: "A Brand That Resonates",
        description:
          "Built for pros, intuitive for all. We've carved out a niche that speaks to experienced traders while staying accessible to those entering the market.",
        icon: (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 6L8 14V34L24 42L40 34V14L24 6ZM36 32.18L24 38.18L12 32.18V15.82L24 9.82L36 15.82V32.18Z" fill="#F44336"/>
            <path d="M24 16C20.69 16 18 18.69 18 22C18 24.97 20.16 27.43 23 27.92V32H25V27.92C27.84 27.43 30 24.97 30 22C30 18.69 27.31 16 24 16ZM24 26C21.79 26 20 24.21 20 22C20 19.79 21.79 18 24 18C26.21 18 28 19.79 28 22C28 24.21 26.21 26 24 26Z" fill="#F44336"/>
          </svg>
        ),
      },
      {
        id: 4,
        title: "A Market-Ready Opportunity",
        description:
          "The future of trading is here. AI-driven and automated trading is booming, and we're positioned to lead the charge—right now.",
        icon: (
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M40 16H36V8H16V12H32V16H8C5.8 16 4 17.8 4 20V32C4 34.2 5.8 36 8 36H12V40H32V36H40C42.2 36 44 34.2 44 32V20C44 17.8 42.2 16 40 16ZM40 32H8V20H40V32Z" fill="#9C27B0"/>
          </svg>
        ),
      },
  ];

  return (
    <section className="benefits-section">
      <div className="container">
        <div className="section-header">
          <h2>Why We're the Best</h2>
          <p>Our platform combines cutting-edge technology with intuitive design to provide unmatched trading capabilities.</p>
        </div>
        
        <div className="benefits-grid">
          {benefits.map(benefit => (
            <div key={benefit.id} className="benefit-card">
              <div className="benefit-icon">
                {benefit.icon}
              </div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
